import { lazy } from 'react';

export const SignatureProtocolPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "SignatureProtocolPage" */
      './SignatureProtocolPage'
    ),
);
